import { Navigate, useNavigate } from "react-router-dom"
import QRCode from "react-qr-code"
import useOtpShow from "./useOtpShow"

const OtpShowPage = () => {
    const {
        baseUrl,
        otpUrl,
        otp,
        status,
        error,
        isActivated,
        setOtp,
        handleStart,
        handleVerify,
    } = useOtpShow()
    const navigate = useNavigate()
    const token = localStorage.getItem("token")
    if (token) return <Navigate to="/home" replace />

    return (
        <main>
            <div className="container">
                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                <div className="card mb-3">
                                    <div className="card-body auth-login">

                                        <div className="pt-4 pb-4 text-center">
                                            <img
                                                src={`${baseUrl}/assets/img/kemenag_logo_mini.png`}
                                                style={{ width: "100px" }}
                                                alt="Logo"
                                            />
                                            <h5 className="card-title fs-4 mt-3">
                                                Aktivasi MFA
                                            </h5>
                                            <p className="small">
                                                Scan QR dari aplikasi Authenticator
                                            </p>
                                        </div>

                                        {error && (
                                            <div className="alert alert-danger">
                                                {error}
                                            </div>
                                        )}

                                        {!isActivated && status !== 'otpEnabled' &&(
                                            <button
                                                className="btn btn-primary w-100 py-2"
                                                onClick={handleStart}
                                                disabled={status === "loading"}
                                            >
                                                {status === "loading" ? "Loading..." : "Mulai"}
                                            </button>
                                        )}
                                        {!isActivated && status === 'otpEnabled' &&(
                                            <button
                                                type="button"
                                                className="btn btn-primary w-100 py-2"
                                                onClick={() => navigate("/otp-input")}
                                            >
                                                Ke Halaman OTP
                                            </button>
                                        )}
                                        {isActivated && (
                                            <form className="row g-3" onSubmit={handleVerify}>
                                                <div className="col-12 d-flex justify-content-center">
                                                    <div style={{ background: "white", padding: 16 }}>
                                                        <QRCode value={otpUrl} size={160} />
                                                    </div>
                                                </div>

                                                {/* <div className="col-12">
                                                    <label className="form-label">OTP</label>
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        maxLength={6}
                                                        value={otp}
                                                        onChange={(e) => setOtp(e.target.value)}
                                                        required
                                                    />
                                                </div> */}

                                                {/* <div className="col-12">
                                                    <button
                                                        className="btn btn-primary w-100 py-2"
                                                        type="submit"
                                                        disabled={otp.length !== 6}
                                                    >
                                                        Aktivasi
                                                    </button>
                                                </div> */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary w-100 py-2"
                                                    onClick={() => navigate("/otp-input")}
                                                >
                                                    Ke Halaman OTP
                                                </button>
                                            </form>
                                        )}

                                    </div>
                                </div>

                                <div className="credits">
                                    Designed by <a href="#">PUSDATIN</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default OtpShowPage
